import PageHeader from "../components/layout/PageHeader";
import SectionTitle from "../components/common/SectionTitle";
import CtaBanner from "../components/common/CtaBanner";
import { partners } from "../data/content";

export default function Partners() {
  return (
    <>
      <PageHeader title="Partners" crumbs={[{ label: "Partners" }]} />
      <section className="section">
        <div className="container">
          <SectionTitle
            subtitle="Our Partners"
            title="Trusted by <span>Leading Brands</span>"
            text="We're proud to partner with industry leaders to deliver the best service possible."
          />
          <div className="partners-grid">
            {partners.map((p, i) => (
              <div className="partner-logo" key={i}>{p}</div>
            ))}
          </div>
        </div>
      </section>
      <CtaBanner />
    </>
  );
}
